import React, { useContext } from 'react';
import PropTypes from 'prop-types';
// import '@fontsource/roboto/700.css';
import SkipPreviousRoundedIcon from '@mui/icons-material/SkipPreviousRounded';
import SkipNextRoundedIcon from '@mui/icons-material/SkipNextRounded';

import './playlists.style.css';
import VideoInfo from './videoInfo';
import PlayPauseBig from '../video/controls/playPauseBig';
import ThemeContext from '../../config/themeContext';
import ReplayButtonBig from '../video/controls/replayButtonBig';

export default function SimplePlaylist({ playlistmodel, videoPlayer }) {
  const theme = useContext(ThemeContext);
  const isNextClass =
    playlistmodel.isNextItem() || playlistmodel.loopEnabled
      ? 'tpx-btn-next-plist'
      : 'tpx-btn-next-plist md-inactive';
  const isPrevious =
    playlistmodel.isPreviousItem() || playlistmodel.loopEnabled
      ? 'tpx-btn-prev-plist'
      : 'tpx-btn-prev-plist md-inactive';

  function handlePrevClick() {
    if (playlistmodel.getPreviousItem()) {
      videoPlayer.skip();
    }
  }

  function handleNextClick() {
    if (playlistmodel.getNextItem()) {
      videoPlayer.skip();
    }
  }

  return (
    <div
      id="tpx-simple-playlist"
      className={`tpx-simple-playlist ${videoPlayer.state.toLowerCase()}`}
    >
      <PlayPauseBig videoPlayer={videoPlayer} state={videoPlayer.state} />
      {!playlistmodel.isPlaylist ? (
        <ReplayButtonBig videoPlayer={videoPlayer} playlistmodel={playlistmodel} />
      ) : null}
      <VideoInfo playlistmodel={playlistmodel} />
      <div className={isNextClass} onClick={handleNextClick}>
        {playlistmodel.isNextItem() || playlistmodel.loopEnabled ? (
          <SkipNextRoundedIcon sx={theme.imageIconMedium} />
        ) : null}
      </div>
      <div className={isPrevious} onClick={handlePrevClick}>
        {playlistmodel.isPreviousItem() || playlistmodel.loopEnabled ? (
          <SkipPreviousRoundedIcon sx={theme.imageIconMedium} />
        ) : null}
      </div>
    </div>
  );
}

SimplePlaylist.propTypes = {
  playlistmodel: PropTypes.object.isRequired,
  videoPlayer: PropTypes.object.isRequired,
};
